import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { gapi, loadAuth2 } from "gapi-script";

import { useSetRecoilState } from "recoil";
import {
  getTokenGoogle,
  profileState,
  signInState,
  temporaryUseAccessToken,
} from "lib/store/user";
import { errorToastState } from "lib/store/common";

import { Button, GoogleIcon } from "@atsent/components";

export type GoogleSignInProps = {
  cx?: string;
};

const REACT_APP_CLIENT_ID =
  "512809385348-85jpgon374ilpmrlthui3iuv7tc31g2e.apps.googleusercontent.com";

export const GoogleSignIn: React.FC<GoogleSignInProps> = ({ cx = "" }) => {
  const setLogged = useSetRecoilState(signInState);
  const setErrorToast = useSetRecoilState(errorToastState);
  const setUser = useSetRecoilState(profileState);
  const setTempToken = useSetRecoilState(temporaryUseAccessToken);
  const navigate = useNavigate();
  useEffect(() => {
    const setAuth2 = async () => {
      const auth2 = await loadAuth2(gapi, REACT_APP_CLIENT_ID, "");
      attachSignIn(document.getElementsByClassName("customBtn")[0], auth2);
    };

    setAuth2();
    //eslint-disable-next-line
  }, []);

  const attachSignIn = (element: any, auth2: any) => {
    auth2.attachClickHandler(
      element,
      {},
      (googleUser: any) => {
        handleGoogleSignIn(googleUser.xc);
      },
      (error: any) => {
        console.log(JSON.stringify(error));
      }
    );
  };

  const handleGoogleSignIn = async ({
    access_token,
  }: {
    access_token: string;
  }) => {
    try {
      const data = await getTokenGoogle({ access_token });

      localStorage.setItem("token", data.access_token);
      localStorage.setItem("refToken", data.refresh_token);

      // 이미 가입 한 유저일경우
      if (!!data.user.agreement) {
        await setUser(data.user);
        await setLogged(true);
        await navigate("/");
      } else {
        await setTempToken(data);
        await navigate("/sign-up");
      }
    } catch (e) {
      setErrorToast(e);
    }
  };

  return (
    <Button icon={<GoogleIcon />} size={"large"} cx={`customBtn ${cx}`} outline>
      Continue with Google
    </Button>
  );
};
